import React, { useContext } from 'react';
// import { Link } from 'react-router-dom';
import { ThemeContext } from '../context/ThemeContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Documentation = () => {
  const { darkMode } = useContext(ThemeContext);
  
  return (
    <div className={`min-h-screen flex flex-col ${darkMode ? 'dark' : ''} bg-gray-50 dark:bg-gray-900`}>
      <Navbar />
      <div className="pt-16 px-4 sm:px-6 lg:px-8 flex-grow">
        <div className="max-w-[1440px] mx-auto py-10">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Documentation</h1>
        
        <div className="flex flex-col md:flex-row gap-8">
          {/* Sidebar */}
          <div className="md:w-64 flex-shrink-0">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-4">
              <h3 className="font-medium text-gray-900 dark:text-white mb-3">Contents</h3>
              <ul className="space-y-2">
                <li>
                  <a href="#getting-started" className="text-blue-600 dark:text-blue-400 hover:underline">Getting Started</a>
                </li>
                <li>
                  <a href="#installation" className="text-blue-600 dark:text-blue-400 hover:underline">Installation</a>
                </li>
                <li>
                  <a href="#basic-usage" className="text-blue-600 dark:text-blue-400 hover:underline">Basic Usage</a>
                </li>
                <li>
                  <a href="#advanced-features" className="text-blue-600 dark:text-blue-400 hover:underline">Advanced Features</a>
                </li>
                <li>
                  <a href="#troubleshooting" className="text-blue-600 dark:text-blue-400 hover:underline">Troubleshooting</a>
                </li>
                <li>
                  <a href="#api-reference" className="text-blue-600 dark:text-blue-400 hover:underline">API Reference</a>
                </li>
              </ul>
            </div>
          </div>

          {/* Main content */}
          <div className="flex-1">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
              <section id="getting-started" className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Getting Started</h2>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Welcome to the Torque Professional documentation. This guide will help you get started with our software and make the most of its features to manage your automotive repair business efficiently.
                </p>
                <p className="text-gray-700 dark:text-gray-300">
                  Torque Professional is designed to streamline your workflow, from customer management to invoicing, and everything in between. Whether you run a small garage or a large service center, our software will help you save time and reduce errors.
                </p>
              </section>

              <section id="installation" className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Installation</h2>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Installing Torque Professional is straightforward. Simply download the appropriate version for your operating system (Windows or Mac) and follow the on-screen instructions.
                </p>
                <div className="bg-gray-100 dark:bg-gray-700 p-4 rounded-md mb-4">
                  <h4 className="font-medium text-gray-900 dark:text-white mb-2">System Requirements</h4>
                  <ul className="list-disc pl-5 text-gray-700 dark:text-gray-300">
                    <li>Windows 10 or later / macOS 10.14 or later</li>
                    <li>4GB RAM (8GB recommended)</li>
                    <li>1GB free disk space</li>
                    <li>1280x768 screen resolution</li>
                    <li>Internet connection for updates and cloud features</li>
                  </ul>
                </div>
              </section>

              <section id="basic-usage" className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Basic Usage</h2>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  After installation, you'll need to create an account or sign in with your existing credentials. Once logged in, you'll be presented with the dashboard, which provides an overview of your business activities.
                </p>
                <p className="text-gray-700 dark:text-gray-300">
                  From the dashboard, you can navigate to different sections of the application using the sidebar menu. The main sections include Customers, Vehicles, Invoices, Inventory, and Reports.
                </p>
              </section>

              <section id="advanced-features" className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Advanced Features</h2>
                <p className="text-gray-700 dark:text-gray-300">
                  Torque Professional includes several advanced features to help you manage your business more effectively. These include custom reporting, automated customer communications, integration with accounting software, and more.
                </p>
              </section>

              <section id="troubleshooting" className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Troubleshooting</h2>
                <p className="text-gray-700 dark:text-gray-300">
                  If you encounter any issues with Torque Professional, our support team is here to help. You can contact us through the in-app support feature or by emailing support@torqueapp.com.
                </p>
              </section>

              <section id="api-reference">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">API Reference</h2>
                <p className="text-gray-700 dark:text-gray-300">
                  For developers looking to integrate with Torque Professional, we provide a comprehensive API. The API documentation covers all endpoints, authentication methods, and example requests and responses.
                </p>
              </section>
            </div>
          </div>
        </div>

        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Documentation;